/**
 * RTWO Event Bus — Readiness Service
 */

import { EVENT_BUS_SERVICE_IDS } from '../domain-models';
import type { EBusReadinessReport, IEBusReadinessService } from '../service-interfaces';
import { EVENT_BUS_VERSION } from '../domain-models';
import { eventBusFederationRegistry } from '../registry/event-bus-federation-registry';
import { BaseEBusService, type EBusServiceContext } from './base-ebus-service';

export class EBusReadinessService extends BaseEBusService implements IEBusReadinessService {
  readonly serviceId = EVENT_BUS_SERVICE_IDS.READINESS_SERVICE;
  readonly serviceName = 'Readiness Service';
  readonly description =
    'Reports Event Bus readiness state. Structure complete — pending real event sources.';
  readonly integrations = ['System Registry', 'All Event Bus Services'];
  readonly requiresRealEventSources = false;

  constructor(context: EBusServiceContext) {
    super(context);
  }

  async initialize(): Promise<void> {
    this.status = 'structure_ready';
  }

  getReadinessReport(): EBusReadinessReport {
    const federationActive = eventBusFederationRegistry.isFederationActive();
    return {
      moduleId: 'RTWO-EBUS-001',
      moduleName: 'Event Bus & Message Broker',
      phase: EVENT_BUS_VERSION.phase,
      status: federationActive ? 'Federation Connected' : 'Structure Complete',
      productionReady: false,
      productionReadiness: federationActive
        ? 'Federation Active — Waiting for Real Runtime Events'
        : 'Pending Federation Activation',
      eventBusReady: true,
      waitingForRealEvents: true,
      noPublishersRegistered: true,
      noSubscribersRegistered: true,
      deadLetterQueueEmpty: true,
      checkedAt: Date.now(),
    };
  }

  isProductionReady(): false {
    return false;
  }

  getReadinessSummary(): string {
    const federationActive = eventBusFederationRegistry.isFederationActive();
    return federationActive
      ? 'Event Bus Federation Connected — No Fabricated Events — Waiting for Real Runtime Activity'
      : 'Event Bus Architecture Ready — Federation Pending — No Publishers Registered — No Subscribers Registered';
  }
}
